<script setup lang="ts">
import { useSectionCustomerDetails } from '../model/section-customer-details.hook'
import CustomerKeyValueCard from './CustomerKeyValueCard.vue'
import CustomerQuizAnswers from './CustomerQuizAnswers.vue'

defineOptions({
  name: 'SectionCustomerDetails',
})

const {
  hasDetails,
  refAnswers,
  refTutorFeedback,
  refSettings,
  refIpInfo,
  refMarketingData,
  refExperiments,
} = useSectionCustomerDetails()
</script>

<template>
  <div
    v-if="hasDetails"
    class="section-customer-details"
  >
    <CustomerQuizAnswers
      v-if="refAnswers.length"
      :answers="refAnswers"
    />
    <CustomerKeyValueCard
      v-if="refTutorFeedback.length"
      title="Tutor feedback"
      key-title="Question title"
      value-title="Answer title"
      :rows="refTutorFeedback"
    />
    <div class="section-customer-details__row">
      <CustomerKeyValueCard
        title="Settings"
        :rows="refSettings"
      />
      <CustomerKeyValueCard
        title="Ip info"
        :rows="refIpInfo"
      />
    </div>
    <div class="section-customer-details__row">
      <CustomerKeyValueCard
        title="Marketing data"
        :rows="refMarketingData"
      />
      <CustomerKeyValueCard
        title="Experiments"
        :rows="refExperiments"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./SectionCustomerDetails.scss" />
